import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { Course } from "src/app/interfaces/response";
import { SectoresProductivosService } from "src/app/services/sectores-productivos.service";
import * as XLSX from "xlsx";

@Component({
  selector: "app-renac-table-principal",
  templateUrl: "./renac-table-principal.component.html",
  styleUrls: ["./renac-table-principal.component.css"],
})
export class RenacTablePrincipalComponent implements OnInit {
  displayedColumns: string[] = [
    "nombreCurso",
    "capacitador",
    "estandar",
    "estado",
    "modalidad",
  ];
  dataSource = new MatTableDataSource<Course>();
  totalElements: number = 0;
  pageSize: number = 30;
  pageNumber: number = 1;
  code: string = "";
  filterTimeout: any;
  debounceTimer: any;
  activeEror: boolean;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @Output() courseSelected = new EventEmitter<Course>();

  constructor(private service: SectoresProductivosService) {}

  ngOnInit(): void {
    this.getCursos(this.pageNumber, this.pageSize, this.code);
  }

  sectorByID(course: Course) {
    this.courseSelected.emit(course);
  }

  getCursos(
    pageNumber: number,
    size: number,
    code: string,
    download?: boolean
  ): void {
    this.service
      .getListaCursos(pageNumber, size, code ? code : this.code)
      .subscribe({
        next: (data) => {
          if (download) {
            this.exportToCSV(data.coursesList);
          } else {
            
            this.totalElements = data.numRows < 30 ? data.numRows : data.totalPages * this.pageSize;
            this.dataSource.data = data.coursesList;
            if (!data.coursesList || data?.coursesList?.length === 0) {
              this.activeEror = true;
            } else {
              this.activeEror = false;
            }
          }
        },
        error: (error) => {
          console.error("Error al obtener cursos:", error);
        },
      });
  }

  onPageChange(event: PageEvent): void {
    this.getCursos(event.pageIndex + 1, event.pageSize, this.code);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      if (filterValue === "") {
        this.getCursos(this.pageNumber, this.pageSize, this.code);
      } else {
        this.getCursos(this.pageNumber, 0, filterValue);
      }
    }, 800);
  }

  applyFilterCode(event: KeyboardEvent) {
    clearTimeout(this.filterTimeout);
    this.filterTimeout = setTimeout(() => {
      const filterValue = (event.target as HTMLInputElement).value;
      this.code = filterValue;
      this.getCursos(this.pageNumber, this.pageSize, this.code);
    }, 800);
  }

  exportToCSV(data: any[]): void {
    const csvContent = this.convertToCSV(data);
    const bom = "\uFEFF";
    const blob = new Blob([bom + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "renac_datos.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private convertToCSV(data: any[]): string {
    if (!data || data.length === 0) {
      return "";
    }

    // Títulos personalizados
    const header = "Nombre del curso,Capacitador,Estandar,Estado,Modalidad";

    // Mapear datos con títulos personalizados
    const rows = data.map((row) =>
      [
        row.nombreCurso,
        row.capacitador,
        row.estandar,
        row.estado,
        row.modalidad,
      ]
        .map((value) => `"${value || ""}"`)
        .join(",")
    );

    return [header, ...rows].join("\n");
  }
}
